module.exports = __webpack_public_path__ + "media/images/flags/dj-5f07a75e0b4602664e67e4f21f4ff0d1.svg";